import API from 'services/api';

export const getReviewInvoice = (invoiceId: string): Promise<Blob> =>
  API.get(`/api/documents/invoices/${invoiceId}/pdf`, { responseType: 'blob' }).then(
    response => response?.data,
  );
